//#region src/components/Nav/Nav.module.css
var Nav_module_default = {
	"nav-bar": "_nav-bar_pmal2_8",
	"nav-bar-items": "_nav-bar-items_pmal2_14",
	"nav-tab": "_nav-tab_pmal2_25",
	"nav-item": "_nav-item_pmal2_50"
};
//#endregion
export { Nav_module_default as default };

//# sourceMappingURL=Nav.module.js.map